import { splitMathSegments } from "../components/math/MathText";

// Split only prose child paragraphs; a marker inside a formula or code stays intact.
export const splitHandoutFocusChildren = (source = "") => {
  const formulas = new Map();
  let prefix = "FOCUSCHILDMATH";
  while (String(source).includes(prefix)) prefix += "X";
  const protectedSource = splitMathSegments(String(source)).map((segment) => {
    if (segment.type === "text") return segment.value;
    const marker = `${prefix}${formulas.size}END`;
    const delimiter = segment.display ? "$$" : "$";
    formulas.set(marker, `${delimiter}${segment.value}${delimiter}`);
    return marker;
  }).join("");
  const restore = (text) => {
    let result = text;
    formulas.forEach((formula, marker) => { result = result.split(marker).join(formula); });
    return result;
  };
  const groups = [];
  let lines = [];
  let marker = "";
  let fence = "";
  const flush = () => {
    if (marker || lines.some((line) => line.trim())) groups.push({ marker, source: restore(lines.join("\n")) });
    lines = [];
    marker = "";
  };
  for (const line of protectedSource.split("\n")) {
    const codeFence = line.match(/^\s*(`{3,}|~{3,})/);
    if (codeFence) fence = fence ? "" : codeFence[1][0];
    const child = !fence && line.match(/^\s*(\(\d+\))\s*(.*)$/);
    if (child) {
      flush(); marker = child[1]; lines.push(child[2]);
    } else {
      if (marker && (!line.trim() || /^\s*#{1,6}\s/.test(line))) flush();
      lines.push(line);
    }
  }
  flush();
  return groups;
};
